function TechCard({ icon, name, description, tag, delay }) {
  return (
    <article
      className="tech-card tech-card--stagger"
      style={{ animationDelay: `${delay}ms` }}
    >
      <i className={`${icon} tech-card-icon`} aria-hidden="true" />

      <h3 className="tech-card-name">{name}</h3>

      <p className="tech-card-description">{description}</p>

      <span className="tech-card-tag">{tag}</span>
    </article>
  );
}

export default TechCard;
